module.exports = __webpack_public_path__ + "img/Airbnb-Landing-Page-Need-More-Help_-1.94ca950f.jpg";